<template>
  <div class="wrapper" v-loading="ifRequesting">
    <div class="searchBar">
      <div>
        证书编号
        <el-input
          placeholder="搜索证书编号"
          size="small"
          style="width: 160px"
          v-model="searchCondition.certificateNum"
        ></el-input>
        &ensp;&ensp; 姓名：
        <el-input
          placeholder="搜索姓名"
          size="small"
          style="width: 160px"
          v-model="searchCondition.userName"
        ></el-input>
        &ensp;&ensp; 身份证：
        <el-input
          placeholder="搜索身份证号"
          size="small"
          style="width: 160px"
          v-model="searchCondition.idCard"
        ></el-input>
        <br />
        <br />
        证书类型：
        <el-select
          placeholder="请选择证书类型"
          v-model="searchCondition.source"
          size="small"
        >
          <el-option value="" label="所有证书类型"></el-option>
          <el-option :value="1" label="考试"></el-option>
          <el-option :value="2" label="转换评价"></el-option>
        </el-select>

        &ensp;&ensp;盖章状态：
        <el-select
          placeholder="请选择盖章状态"
          v-model="searchCondition.sealStatus"
          size="small"
        >
          <el-option value="" label="所有盖章状态"></el-option>
          <el-option :value="0" label="待盖章"></el-option>
          <el-option :value="1" label="盖章成功"></el-option>
          <el-option :value="2" label="盖章失败"></el-option>
          <el-option :value="3" label="盖章中"></el-option>
        </el-select>
        &ensp;&ensp;颁发状态：
        <el-select
          placeholder="请选择颁发状态："
          v-model="searchCondition.awardStatus"
          size="small"
        >
          <el-option value="" label="所有颁发状态"></el-option>
          <el-option :value="0" label="未颁发"></el-option>
          <el-option :value="1" label="已颁发"></el-option>
        </el-select>

        &ensp;&ensp; 起始时间：
        <el-date-picker
          style="width: 200px"
          size="small"
          v-model="searchCondition.rangeTime"
          type="daterange"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="
            (value) => {
              [searchCondition.startTime, searchCondition.endTime] = value || [
                '',
                '',
              ];
            }
          "
        >
        </el-date-picker>
        <!-- <el-date-picker
          type="date"
          placeholder="上传登记时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchCondition.createTime"
        >
        </el-date-picker> -->

        &ensp;&ensp;
        <el-button type="primary" size="small" @click="getData">查询</el-button>
        <el-button
          type="primary"
          size="small"
          @click="
            Object.assign(searchCondition, $options.data().searchCondition)
          "
          >重置</el-button
        >
      </div>
    </div>
    <div class="content">
      <div class="actBar">
        <!-- <div>
          <el-upload
            action="/base/common/importAuditExcel"
            :show-file-list="false"
            :on-success="importSuccess"
            :before-upload="
              () => {
                ifRequesting = true;
              }
            "
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </div> -->
        <div>
          <el-dropdown
            @command="
              (command) => {
                makeSeal(null, command);
              }
            "
          >
            <el-button size="small" type="primary"> 证书盖章 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="true"
                :disabled="selectList.length == 0"
                >证书盖章</el-dropdown-item
              >
              <el-dropdown-item
                :command="false"
                :disabled="searchCondition.total == 0"
                >所有证书一键盖章</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button slot="reference" size="small" @click="makeSeal()"
            >一键盖章</el-button
          > -->
          &emsp;
          <el-dropdown
            @command="
              (command) => {
                makeAward(null, command);
              }
            "
          >
            <el-button size="small" type="primary"> 证书颁发 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="true"
                :disabled="selectList.length == 0"
                >颁发勾选证书</el-dropdown-item
              >
              <el-dropdown-item
                :command="false"
                :disabled="searchCondition.total == 0"
                >一键颁发所有证书</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button slot="reference" size="small" @click="makeAward()"
            >一键颁发</el-button
          > -->
          （点击查询后记录筛选条件）
        </div>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          @selection-change="
            (e) => {
              selectList = e;
            }
          "
          border
          style="width: 100%"
          ref="transformTable"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>

          <el-table-column
            prop="certificateName"
            label="证书名称"
            width="240px"
          >
          </el-table-column>
          <el-table-column prop="userName" label="学员姓名" width="80px">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180px">
          </el-table-column>

          <el-table-column prop="certificateNum" label="证书编号" width="160px">
          </el-table-column
          ><el-table-column prop="sourceText" label="证书类型" width="160px">
          </el-table-column
          ><el-table-column prop="validity" label="有效期" width="100px">
          </el-table-column
          ><el-table-column prop="award" label="颁发机构" min-width="160px">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120px">
          </el-table-column>
          <el-table-column prop="createTime" label="上传登记时间" width="105px">
          </el-table-column>

          <el-table-column
            prop="sealStatusText"
            label="盖章状态"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column prop="sealTime" label="盖章时间" min-width="100px">
          </el-table-column>
          <el-table-column
            prop="awardStatusText"
            label="颁证状态"
            min-width="100px"
          >
          </el-table-column
          ><el-table-column prop="awardTime" label="颁证时间" min-width="100px">
          </el-table-column>
          <el-table-column align="center" width="400" label="操作">
            <template slot-scope="{ row }">
              <!-- <el-button
                :disabled="!row.certificateImage"
                size="small"
                @click="previewImage([row.certificateImage])"
              >
                预览</el-button
              >&ensp; -->
              <el-button slot="reference" size="small" @click="showLog(row)"
                >查看记录</el-button
              >

              <el-button
                slot="reference"
                size="small"
                :disabled="row.auditStatus != 1 || row.sealStatus == 1"
                @click="makeSeal(row)"
                >证书盖章</el-button
              ><el-button
                slot="reference"
                size="small"
                :disabled="row.sealStatus != 1 || row.awardStatus == 1"
                @click="makeAward(row)"
                >证书颁发</el-button
              >
              <el-button
                slot="reference"
                size="small"
                @click="previewCertificate(row)"
                >预览证书</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <el-image-viewer
      v-if="previewImageList.length > 0"
      :on-close="
        () => {
          previewImageList = [];
        }
      "
      :url-list="previewImageList"
    /> -->
    <el-dialog
      title="证书预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
    <el-dialog
      title="审核意见"
      append-to-body
      :visible.sync="auditDialogIfShow"
      width="40%"
    >
      <div>当前选择 {{ auditData ? 1 : selectList.length }} 条记录</div>
      <div class="dialogContent">
        <el-input placeholder="请输入审核意见" v-model="auditRemark"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="auditSubmit('auditOk')"
          >通过</el-button
        >
        <el-button size="small" type="danger" @click="auditSubmit('auditNotOk')"
          >拒绝</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="审核日志"
      :visible.sync="auditLog.ifShow"
      width="40%"
      :append-to-body="true"
      top="2vh"
    >
      <el-timeline>
        <el-timeline-item
          v-for="item in auditLog.data"
          :timestamp="item.createTime"
          placement="top"
        >
          <el-card>
            <div
              class="spaceBetween"
              style="display: flex; justify-content: space-between"
            >
              <h4>{{ item.typeText }}</h4>
              <div>{{ item.createTime }}</div>
            </div>
            <p>{{ item.auditStatusText }}</p>
            <p>{{ item.auditorText }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
import Util from "@/libs/util";
import {
  certificateAuditList,
  certificateAudit,
  previewCertificate,
  awardCertificate,
  sealCertificate,
  getCertificateAuditLog,
  //   exportCertificateTransform,
} from "@/api/certificate.js";
export default {
  data() {
    return {
      ifRequesting: false,
      dataList: [],
      selectList: [],
      auditLog: { ifShow: false, data: [] },
      previewImageList: [],
      searchCondition: {
        type: 3,
        certificateNum: "",
        userName: "",
        idCard: "",
        auditStatus: "",
        auditor: "",
        pageNumber: 1,
        pageSize: 10,
        rangeTime: "",
        startTime: "",
        endTime: "",
        createTime: "",
        source: "",
        sealStatus: "",
        awardStatus: "",
      },
      searchConditionUsed: {},
      auditLock: false,
      auditDialogIfShow: false,
      auditRemark: "",
      auditData: {},
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  components: { elImageViewer, pdfPreview },
  methods: {
    showLog(item) {
      getCertificateAuditLog({ id: item.id }).then((data) => {
        this.auditLog.data = data.data.auditList;
        this.auditLog.ifShow = true;
        console.log(data);
      });
    },

    previewCertificate(item) {
      this.ifRequesting = true;
      previewCertificate({ id: item.id }).then((data) => {
        if (data.code == 200) {
          this.pdfData.pdfUrl = data.data;
          console.log(data.data);
          this.pdfData.pdfIfShow = true;
          this.ifRequesting = false;
        }
      });
    },
    makeSeal(row = false, ifSelect) {
      let postData = {};
      if (row) {
        postData = { ids: [row.id] };
      } else if (ifSelect) {
        if (
          this.selectList.findIndex(
            (item) => item.sealStatus == 3 || item.sealStatus == 1
          ) > -1
        ) {
          this.$alert("当前勾选项存在不可盖章项");
          return;
        }
        postData = {
          ids: this.selectList
            .filter((item) => item.auditStatus == 1)
            .map((item) => item.id),
        };
      } else {
        postData = this.searchConditionUsed;
      }
      this.$confirm(
        `将${this.selectList.length == 0 && !row ? "在该筛选条件下" : ""}盖章${
          row ? 1 : ifSelect ? postData.ids.length : this.searchCondition.total
        }项`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        () => {
          this.ifRequesting = true;
          sealCertificate(postData).then((data) => {
            if (data.code == 200) {
              this.getData();
              this.ifRequesting = true;
              this.$alert(data.data);
            }
          });
        },
        () => {
          return;
        }
      );
    },
    makeAward(row = false, ifSelect) {
      let postData = {};

      if (row) {
        postData = { ids: [row.id] };
      } else if (ifSelect) {
        if (this.selectList.findIndex((item) => item.sealStatus != 1) > -1) {
          this.$alert("当前勾选项存在不可颁发项");
          return;
        }
        postData = {
          ids: this.selectList
            .filter((item) => item.sealStatus == 1)
            .map((item) => item.id),
        };
      } else {
        postData = this.searchConditionUsed;
      }
      this.$confirm(
        `将${this.selectList.length == 0 && !row ? "在该筛选条件下" : ""}颁发${
          row ? 1 : ifSelect ? postData.ids.length : this.searchCondition.total
        }项`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        () => {
          this.ifRequesting = true;
          awardCertificate(postData).then((data) => {
            if (data.code == 200) {
              this.getData();
              this.ifRequesting = false;
              this.$alert(data.data);
            }
          });
        },
        () => {
          return;
        }
      );
    },

    importSuccess(res, file) {
      this.ifRequesting = false;
      console.log(res);
      if (res.code == 200) {
        this.$message.success("导入成功");
        this.getData();
      } else {
        this.$alert(res.info, "提示");
      }
    },
    // previewImage(urlList) {
    //   if (urlList[0]) {
    //     this.previewImageList = urlList;
    //   } else {
    //     this.$message.warning("此申请没有提供图片数据");
    //   }
    // },
    getData() {
      let postData = {};
      for (const i in this.searchCondition) {
        if (this.searchCondition[i] || this.searchCondition[i] === 0) {
          postData[i] = this.searchCondition[i];
        }
      }
      this.ifRequesting = true;
      certificateAuditList(postData).then((data) => {
        // data.rows.forEach((item) => {
        //   item.auditRemark = "";
        // });
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        this.auditLock = false;
        let searchConditionUsed = {};
        Object.assign(searchConditionUsed, postData);
        this.searchConditionUsed = searchConditionUsed;
        this.ifRequesting = false;
      });
    },
    auditSubmit(status) {
      if (this.auditLock) {
        return;
      }

      this.auditLock = true;
      let item = this.auditData || null;
      console.log(item);
      certificateAudit({
        auditIds: item ? [item.id] : this.selectList.map((item) => item.id),
        auditStatus: status,
        type: this.searchCondition.type,
        auditRemark: this.auditRemark,
      }).then((data) => {
        this.$message.success("审核成功");
        this.getData();
        this.auditDialogIfShow = false;
      });
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
